module.exports = __webpack_public_path__ + "static/media/helexia_icon_money.1965496e.svg";